import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { startLanguage } from "./i18n";
import { applyDisplay } from "./display";
import { fromBrand } from "./theme";
import { branding } from "./brand";
import "./tokens.css";
import "./controls.css";
import "./styles.css";
import "./design.css";
import "./chat.css";
import "./popups.css";
import "./install";

// Installable as a desktop app (ADR-0014). Browsers allow service workers
// only over HTTPS or on localhost.
if (import.meta.env.PROD && "serviceWorker" in navigator && window.isSecureContext) {
  addEventListener("load", () => void navigator.serviceWorker.register("/sw.js").catch(() => {}));
}

// The branding's accent, written into the page, from the first paint.
fromBrand(branding().accent);
applyDisplay();

// The language's strings load first, so the app starts in it.
void startLanguage().then(() =>
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  ),
);
